import React, { FC, memo, useMemo } from 'react';
import Box from '@mui/material/Box';
import BodyTopBlock, { ActionType } from 'src/components/BodyTopBlock';
import { colors, sizes } from 'src/themes/default';
import { getSettingsTopBlockParams, getWebhooksSubTabsParams } from './functions';

type WebhooksSettingsTopBlockProps = {
    actions?: ActionType[];
};

const MainSettingsTabs = memo(
    ({
        tabs,
        selected,
        onChangeTab,
    }: {
        tabs: ReturnType<typeof getSettingsTopBlockParams>['tabs'];
        selected: string;
        onChangeTab: (newUrl: string) => void;
    }) => <BodyTopBlock tabs={tabs} selectTab={selected} onChangeTab={onChangeTab} />,
);

const WebhooksSettingsTopBlock: FC<WebhooksSettingsTopBlockProps> = (props) => {
    const mainParams = getSettingsTopBlockParams();
    const subParams = getWebhooksSubTabsParams();
    const mainTabs = useMemo(
        () => (
            <MainSettingsTabs
                tabs={mainParams.tabs}
                selected={mainParams.selected}
                onChangeTab={mainParams.handleChange}
            />
        ),
        [mainParams.tabs, mainParams.selected, mainParams.handleChange],
    );

    return (
        <Box
            sx={{
                position: 'sticky',
                top: `-${sizes.body_PD}`,
                zIndex: 1000,
                background: colors.background_W,
                marginTop: `-${sizes.body_PD}`,
                paddingTop: sizes.body_PD,
                '& .body-top-block': {
                    position: 'relative',
                    top: 'auto',
                    marginTop: 0,
                    paddingTop: 0,
                    zIndex: 'auto',
                },
                '& .body-top-block + .body-top-block': {
                    marginTop: '-8px',
                    paddingTop: 0,
                },
            }}
        >
            {mainTabs}
            <BodyTopBlock
                tabs={subParams.tabs}
                selectTab={subParams.selected}
                onChangeTab={subParams.handleChange}
                actions={props.actions}
            />
        </Box>
    );
};

export default WebhooksSettingsTopBlock;
